export const isArrayEquals = (
	array1: number[] | (string | undefined)[],
	array2: number[] | (string | undefined)[],
) => {
	return (
		array1.length == array2.length &&
		array1.every(function (element, index) {
			return (
				element === array2[index] ||
				array2.find(elem => elem === element)
			);
		})
	);
};